'use client';

import Image from 'next/image';
import Link from 'next/link';

export default function AssociationCertificate() {
  return (
    <div className="flex w-full items-center">
      <div className="flex items-center justify-center space-x-2">
        <Image
          src={'/images/ai_association.svg'}
          alt="Association"
          width={50}
          height={50}
        />
        <div className="max-w-[160px] text-sm font-semibold text-white">
          Member of the German AI Association
        </div>
      </div>
      <Link
        href="http://www.invest-wagniskapital.de/"
        target="_blank"
        rel="noreferrer"
        prefetch={false}
      >
        <Image
          src="/images/invest.png"
          alt="www.invest-wagniskapital.de"
          width={100}
          height={100}
        />
      </Link>
    </div>
  );
}
